<template>
	<div>
		<div class="event-head pb-4" v-if="item" :class="{ minified }">
			<div class="image" v-if="item && item.image" :style="`background-image: url(${item.image.url})`"></div>
			<div class="data flex-grow-1">
				<span class="d-flex">
					<i class="dot mt-1 mr-1" :class="`dot-${item.statusClass}`"></i>
					<span>{{ item.statusText }}</span>
					<span v-if="item.status == 'ACTIVE' && item.isProgrammed" class="ml-1">
						para el día {{ item.publicFrom | moment("ddd DD MMM HH:mm") }}
					</span>
				</span>

				<h1>{{ item.name }}</h1>
				<div class="description">
					{{ item.startAt | moment("ddd DD MMM HH:mm") }} -
					{{ item.endAt | moment("ddd DD MMM HH:mm") }}
					<br />
					<strong>{{ item.location.name }}</strong> • {{ item.location.address }},
					<span>{{ item.location.locality.name }}, </span>
					<span>{{ item.location.locality.region.name }}</span>
				</div>
				<div>Código de evento: #{{ item.code }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import gql from "graphql-tag"

export default {
	name: "EventDetailHeader",
	props: {
		eventId: {
			type: String,
			required: true
		},
		minified: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			item: null,
			loading: false
		}
	},
	async beforeMount() {
		this.filters = this.getValidUrlParams()
		await this.load()
	},
	methods: {
		async load() {
			this.loading = true
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							event(id: $id) {
								id
								code
								name
								startAt
								endAt
								description
								isProgrammed
								publicFrom
								image {
									id
									type
									filename
									url
									urlThumb
								}
								location {
									id
									name
									locality {
										name
										region {
											name
										}
									}
									address
									latlng {
										lat
										lng
									}
								}

								status
								statusText
								statusClass
							}
						}
					`,
					variables: { id: this.eventId },
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.loading = false
					this.item = data.event
					return data.event
				})
				.catch(() => {})
		}
	}
}
</script>

<style scoped lang="scss">
.event-head {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	padding: 0px;

	.image {
		width: 100px;
		height: 100px;
		border-radius: 8px;
		background-color: #eee;
		background-size: cover;
		background-position: center;
		margin-right: 1rem;
	}

	.data {
		padding: 0x 16px;
		flex-grow: 1;

		.badge {
			border-radius: 3px;
			display: inline-block;
			padding: 1px 8px;
			font-weight: 500;
			// background-color: rgb(255, 241, 233);
			// color: rgb(212, 48, 2);
			font-size: 12px;
			line-height: 20px;
			margin-bottom: 4px;
		}

		h1 {
			margin-bottom: 0px;
			font-weight: 600;
			font-size: 24px;
			line-height: 32px;
		}
		.description {
			strong {
				font-weight: 500;
			}
		}
	}
}
</style>
